export default {
  SET_PRODUCTS_IN_CATEGORY: "SET_PRODUCTS_IN_CATEGORY",
  SET_ALL_FILTERS: "SET_ALL_FILTERS",
};
